// Asks KAS to run its KWP import now, instead of waiting for the hourly cron. The call
// runs the import synchronously, so it can take a while before an answer comes back.
const MINIMUM_BUSY_MS = 500;

document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('#contract-batch-kas-import');
    if (!button) {
        return;
    }

    const message = document.querySelector('#contract-batch-import-message');
    const label = button.textContent;

    /**
     * @returns {string} the CSRF token, or empty when the meta tag is gone
     */
    function csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.content : '';
    }

    /**
     * @param {string} text - the message to show
     * @param {boolean} failed - style it as a failure
     */
    function show(text, failed) {
        if (!message) {
            return;
        }
        message.textContent = text;
        message.className = 'contract-batch-import-message' + (failed ? ' invalid-feedback d-block' : '');
    }

    button.addEventListener('click', function () {
        // KAS can answer within a few dozen milliseconds when there is nothing waiting,
        // and the busy text would flash by without being readable
        const startedAt = Date.now();

        /**
         * Run the follow-up, but never before the busy text has been readable.
         *
         * @param {function(): void} work - what to do once the button is free again
         */
        function finish(work) {
            setTimeout(function () {
                button.disabled = false;
                button.textContent = label;
                work();
            }, Math.max(0, MINIMUM_BUSY_MS - (Date.now() - startedAt)));
        }

        button.disabled = true;
        button.textContent = button.dataset.busy || label;
        // the button already says it is busy; clear the area below so an earlier answer
        // does not sit there looking like this one
        show('', false);

        fetch(button.dataset.url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrfToken(),
            },
        }).then(function (response) {
            return response.json().catch(function () {
                return null;
            }).then(function (result) {
                return {ok: response.ok, result: result};
            });
        }).then(function (answer) {
            finish(function () {
                // the portal hands its own exceptions back as a 200 with an Error field,
                // so response.ok on its own would let a failure read as success
                const failed = (!answer.ok || !answer.result || answer.result.Error);

                if (failed) {
                    const text = (answer.result && (answer.result.message || answer.result.Error));
                    show(text || button.dataset.failed || '', true);
                    return;
                }

                show(answer.result.message || '', false);
            });
        }).catch(function () {
            finish(function () {
                show(button.dataset.failed || '', true);
            });
        });
    });
});
